<form [formGroup]="form" class="profile-address__wrapper" (submit)="onSubmit()">
  <div class="row">
    <div class="col-6">
      <div class="form-group">
        <label for="">Company</label>
        <input
          type="text"
          class="lum-input"
          formControlName="companyName"
          placeholder="Company"
        />
        <mat-error *ngIf="companyNameControl && companyNameControl.invalid">{{
          companyNameControl | validateField
        }}</mat-error>
      </div>
    </div>
    <div class="col-6">
      <div class="form-group">
        <label for="">Address Line 1</label>
        <input
          type="text"
          class="lum-input"
          formControlName="address"
          placeholder="Address Line 1"
        />
        <mat-error *ngIf="addressControl && addressControl.invalid">{{
          addressControl | validateField
        }}</mat-error>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-6">
      <div class="form-group">
        <label for="">Address Line 2</label>
        <input
          type="text"
          class="lum-input"
          formControlName="addressLine2"
          placeholder="Address Line 2"
        />
      </div>
    </div>
    <div class="col-6">
      <div class="form-group">
        <label for="">State</label>
        <input
          type="text"
          class="lum-input"
          formControlName="state"
          placeholder="State"
        />
        <mat-error *ngIf="stateControl && stateControl.invalid">{{
          stateControl | validateField
        }}</mat-error>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-6">
      <div class="form-group">
        <label for="">City</label>
        <input
          type="text"
          class="lum-input"
          formControlName="city"
          placeholder="City"
        />
        <mat-error *ngIf="cityControl && cityControl.invalid">{{
          cityControl | validateField
        }}</mat-error>
      </div>
    </div>
    <div class="col-6">
      <div class="form-group">
        <label for="">Zip Code</label>
        <input
          type="text"
          class="lum-input"
          formControlName="postalCode"
          placeholder="Zip Code"
        />
        <mat-error *ngIf="postalCodeControl && postalCodeControl.invalid">{{
          postalCodeControl | validateField
        }}</mat-error>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-6">
      <div class="form-group">
        <label for="">Country</label>
        <mat-select formControlName="country" class="lum-select">
          <mat-option *ngFor="let country of countryList" [value]="country.value">
            {{ country.label }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="countryControl && countryControl.invalid">{{
          countryControl | validateField
        }}</mat-error>
      </div>
    </div>
  </div>
  <div class="row mt-4 w-p100">
    <div class="lum-modal__action">
      <button
        type="submit"
        [disabled]="hasInvalidInput || (loading$ | async)"
        class="lum-button mx-4 lum-button--large"
      >
        <ng-container *ngIf="!(loading$ | async); else loader"> Save </ng-container>
        <ng-template #loader>
          <mat-progress-spinner
            class="progress-spinner"
            diameter="16"
            mode="indeterminate"
          ></mat-progress-spinner>
        </ng-template>
      </button>
    </div>
  </div>
</form>
